'use client';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, } from 'react';
import loadingComponentContext from '../contexts/loading-component.js';
import useTranslate from '../hooks/use-translate.js';
import mapChildrenToTranslationKey from '../utils/map-children-to-translation-key.js';
export default function I18n({ children, ...vars }) {
    const LoadingComponent = useContext(loadingComponentContext);
    const translate = useTranslate();
    const translation = translate(mapChildrenToTranslationKey(children), vars);
    if (typeof translation === 'undefined') {
        return _jsx(LoadingComponent, {});
    }
    return _jsx(_Fragment, { children: translation });
}
//# sourceMappingURL=i18n.js.map